import { useLocation } from 'react-router';

import NotificationPollingBootstrap from './NotificationPollingBootstrap';
import SessionManagerBootstrap from './SessionManagerBootstrap';
import TokenRefreshBootstrap from './TokenRefreshBootstrap';

const publicContentPaths = new Set(['/customer-consent', '/shipment-receipt']);

export default function AppLifecycleBootstrap() {
    const { pathname } = useLocation();

    if (publicContentPaths.has(pathname.replace(/\/+$/, ''))) return null;

    return (
        <>
            <TokenRefreshBootstrap />
            <SessionManagerBootstrap />
            <NotificationPollingBootstrap />
        </>
    );
}
